<template>

  <a-select
    v-if="async"
    showSearch
    labelInValue
    :disabled="disabled"
    :getPopupContainer="getParentContainer"
    @search="loadData"
    :placeholder="placeholder"
    v-model="selectedAsyncValue"
    style="width: 100%"
    :filterOption="false"
    @change="handleAsyncChange"
    allowClear
    :notFoundContent="loading ? undefined : null"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small"/>
    <a-select-option v-for="d in options" :key="d.value" :value="d.value">{{ d.text }}</a-select-option>
    <a-select-option v-if="truncated" key="__dict_truncated__" value="__dict_truncated__" disabled>匹配结果超过 {{pageSize}} 条，请输入更精确的关键字</a-select-option>
  </a-select>

  <a-select
    v-else
    :getPopupContainer="getParentContainer"
    showSearch
    :disabled="disabled"
    :placeholder="placeholder"
    optionFilterProp="children"
    optionLabelProp="label"
    style="width: 100%"
    @change="handleChange"
    :filterOption="filterOption"
    :value="selectedValue"
    allowClear
    :notFoundContent="loading ? undefined : null">
    <a-spin v-if="loading" slot="notFoundContent" size="small"/>
    <a-select-option v-for="d in options" :key="d.value" :label="d.text" :value="d.value">{{ d.text }}</a-select-option>
  </a-select>

</template>

<script>
  import { ajaxGetDictItems,getDictItemsFromCache,ajaxGetActiveItems } from '@/api/api'
  import debounce from 'lodash/debounce';
  import { getAction } from '../../api/manage'

  export default {
    name: 'JSearchSelectTag',
    props:{
      disabled: Boolean,
      value: [String, Number],
      dictOptions: Array,
      async: Boolean,
      placeholder:{
        type:String,
        default:"请选择",
        required:false
      },
      dict:{
        type: String,
        default: '',
        required: false
      },
      popContainer:{
        type:String,
        default:'',
        required:false
      },
      pageSize:{
        type: Number,
        default: 50,
        required: false
      },
      getPopupContainer: {
        type:Function,
        default: null
      },
    },
    data(){
      this.loadData = debounce(this.loadData, 800);//消抖
      this.lastLoad = 0;
      return {
        loading:false,
        selectedValue:[],
        selectedAsyncValue:[],
        options: [],
        truncated: false,
      }
    },
    created(){
      //this.async = true
      this.initDictData();
    },
    watch:{
      "value":{
        immediate:true,
        handler(val){
          if(!val){
            if(val==0){
              this.initSelectValue()
            }else{
              this.selectedValue=[]
              this.selectedAsyncValue=[]
            }
          }else{
            this.initSelectValue()
          }
        }
      },
      "dict":{
        handler(){
          this.initDictData()
        }
      },
      'dictOptions':{
        deep: true,
        handler(val){
          if(val && val.length>0){
            this.options = [...val]
          }
        }
      }
    },
    methods:{
      initSelectValue(){
        if(this.async){
          if(!this.selectedAsyncValue || !this.selectedAsyncValue.key || this.selectedAsyncValue.key!=this.value){
            getAction(`/sys/dict/loadDictItem/${this.dict}`,{key:this.value}).then(res=>{
              if(res.success){
                let obj = {
                  key:this.value,
                  label:res.result && res.result[0]
                }
                this.selectedAsyncValue = {...obj}
              }
            })
          }
        }else{
          this.selectedValue = this.value.toString()
        }
      },
      loadData(value){
        if(value === undefined || value === ''){
          return
        }
        if(value.length < 2){
          //this.$message.warning('关键字太短，至少两个字符')
          return
        }
        this.lastLoad +=1
        const currentLoad = this.lastLoad
        this.options = []
        this.truncated = false
        this.loading=true
        // 字典code格式：table,text,code
        getAction(`/sys/dict/loadDict/${this.dict}`,{keyword:value, pageSize: this.pageSize}).then(res=>{
          this.loading=false
          if(res.success){
            if(currentLoad!=this.lastLoad){
              return
            }
            // 后端多取一条用于判断是否还有更多匹配：超出部分不展示，只提示继续输入
            const list = res.result || []
            this.truncated = list.length > this.pageSize
            this.options = this.truncated ? list.slice(0, this.pageSize) : list
          }else{
            this.$message.warning(res.message)
          }

        })

      },
      initDictData(){
        if(!this.async){
          //如果字典项集合有数据
          if(this.dictOptions && this.dictOptions.length>0){
            this.options = [...this.dictOptions]
          }else{
            //根据字典Code, 初始化字典数组
            let dictStr = ''
            if(this.dict){
              if(this.dict.startsWith("active")){
                //替换把active.前缀去掉
                let dictStr = this.dict.replace("active,","");
                debugger;
                ajaxGetActiveItems(dictStr, null).then((res) => {
                  if (res.success) {
                    this.options = res.result;
                  }
                })
              }else{
                //去掉添加的辅助更新字符串(时间戳字段)
                let tmpStr = this.dict //不能在内部改变dict属性值，被监视
                let i = tmpStr.indexOf("and _t=")
                if(i >0){
                  tmpStr = tmpStr.substr(0,i).trim()
                }

                let arr = tmpStr.split(',')
                if(arr[0].indexOf('where')>0){
                  let tbInfo = arr[0].split('where')
                  dictStr = tbInfo[0].trim()+','+arr[1]+','+arr[2]+','+encodeURIComponent(tbInfo[1])
                }else{
                  dictStr = tmpStr
                }

                if (tmpStr.indexOf(",") == -1) {
                  //优先从缓存中读取字典配置
                  let dictItemsFromCache = getDictItemsFromCache(this.dictCode);
                  if (dictItemsFromCache) {
                    this.options = dictItemsFromCache;
                    return
                  }
                }
                ajaxGetDictItems(dictStr, null).then((res) => {
                  if (res.success) {
                    this.options = res.result;
                  }
                })
              }
            }
          }
        } else {
          //异步不预先加载数据
        }
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      handleChange (selectedVal) {
        this.selectedValue = selectedVal
        this.callback()
      },
      handleAsyncChange(selectedObj){
        // 搜索查询组件，删除条件，默认下拉还是上次的缓存数据
        if(selectedObj){
          this.selectedAsyncValue = selectedObj
          this.selectedValue = selectedObj.key
        }else{
          this.selectedAsyncValue = null
          this.selectedValue = null
          this.options = null
          this.truncated = false
          this.loadData("")
        }
        this.callback()
      },
      callback(){
        // 寻找对应名称，并返回
        let text = null;
        if(this.options && this.options.length >0){
          this.options.forEach((item)=>{
            if(item.value === this.selectedValue){
              text = item.text;
            }
          })
        }
        this.$emit('change', this.selectedValue, text);
      },
      setCurrentDictOptions(dictOptions){
        this.options = dictOptions
      },
      getCurrentDictOptions(){
        return this.options
      },

      getParentContainer(node){
        if(typeof this.getPopupContainer === 'function'){
          return this.getPopupContainer(node)
        } else if(!this.popContainer){
          return node.parentNode
        }else{
          return document.querySelector(this.popContainer)
        }
      },
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style scoped>

</style>